import axios, { Axios } from "axios";
// import getServerInfo from "../Config";
import { json } from "react-router-dom";
import { getServerInfo } from "../util/auth";
import L from "leaflet";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
/* global mapboxgl */
import { svgToImage } from './svg-to-png.js'
/* global L */
import { redMarkerIcon,greenMarkerIcon,markerShadow } from "src/util/mapImages";
import "src/components/ArchilogicMap/Archilogic.css"
import { isAssetAlarmed } from "src/util/utilFunctions";
const greenMarker = new L.Icon({
  iconUrl: greenMarkerIcon,
  iconRetinaUrl: greenMarkerIcon,
  shadowUrl: markerShadow,
  iconSize: [27, 40],
  iconAnchor: [16, 32],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});

export async function loadFloorOnMapHook(floorId, publishableToken,customAssets,assetCallback,map) {
 

  addBaseLayer(map)
  // load svg from space api
  const { imageUrl, latLngBounds } = await loadFloorPlanImage(floorId, publishableToken)
  // add as image overlay
  if(imageUrl && latLngBounds){
  L.imageOverlay(imageUrl, latLngBounds).addTo(map)
  map.fitBounds(latLngBounds)}
  var  imageCenter =[(latLngBounds[0][0] + latLngBounds[1][0]) / 2, (latLngBounds[0][1] + latLngBounds[1][1]) / 2];

  // Set the map's center to the center point of the image overlay
 
  const spaceFeatures = await loadGeoJson(floorId, 'space', publishableToken, map)
  console.log("spaceFeatures",spaceFeatures);
  const workSpaceIds = spaceFeatures.features
    .filter((spaceFeature) => spaceFeature.properties.program === 'work')
    .map((spaceFeature) => spaceFeature.id)

  // check space taxonomy for details
  // https://developers.archilogic.com/space-api/v2/space-taxonomy.html#hierarchy
  spaceFeatures.features = spaceFeatures.features.filter((spaceFeature) =>
    ['meet', 'socialize', 'care'].includes(spaceFeature.properties.program)
  )
  map.on("click", function(e){
    console.log(" electric long lat ",[e.latlng.lat, e.latlng.lng])
   // new L.Marker([e.latlng.lat, e.latlng.lng],{icon: greenMarker}).addTo(map);
 })
 
  const assetFeatures = await loadGeoJson(floorId, 'asset', publishableToken, map)
  console.log("assetFeatures : ",assetFeatures);
  
  // check product taxonomy for details
  // https://developers.archilogic.com/space-api/v2/product-taxonomy.html#hierarchy
  assetFeatures.features = assetFeatures.features.filter((assetFeature) => {
    const isWorkSpace = workSpaceIds.includes(assetFeature.resourceRelations.spaces[0])
    const isDeskOrChair =
      assetFeature.properties.subCategories.includes('desk') ||
      assetFeature.properties.subCategories.includes('taskChair')
    return isWorkSpace && isDeskOrChair
  })
 
if(customAssets){
  console.log("custom  asseets", customAssets)
  mapAssets(assetFeatures,customAssets) //map Archilogic assets to Alis assets
}
if(spaceFeatures){
addGeoJson(spaceFeatures, map)}
if(assetFeatures){
  addGeoJson(assetFeatures, map,assetCallback)}
  map.setView(imageCenter,22)
  //map.setZoom(19);
  var marker = new L.Marker(imageCenter,{icon: greenMarker}).addTo(map);
 
}




// Query resources from floorId and add their Geo JSON polygon contours
export function loadGeoJson(floorId, resourceType = 'space', publishableToken) {
  return fetch(
    `https://api.archilogic.com/v2/${resourceType}?floorId=${floorId}&geometry=true&pubtoken=${publishableToken}`
  ).then((res) => res.json())
}

function addGeoJson(geoJson, map,assetCallback) {
  const COLORS = {
    meet: '#52BE80',
    socialize: '#5499C7',
    care: '#5D6D7E'
  }
  const DEFAULT_COLOR = '#EB984E'
  const geoJSONLayer = L.geoJSON(geoJson, {
    style: function (feature) {
      if (feature.isAssetAlarmed)
      return{
        color: "#FF0000",    
        className:'blinkAsset' 
    }
      else
      return {
        color: COLORS[feature.properties.program] || DEFAULT_COLOR
      }
    }
  })
    .bindTooltip(function (layer) {
      const ft = layer.feature
      return featureInfo(ft) // Needs to be a string
    }) //, {permanent: true, opacity: 0.5}
    .addTo(map).on("click", function(e){
      const clickedLayer = e.layer; // Get the clicked layer
      const ft = clickedLayer.feature; // Get the feature from the clicked layer
    if(ft.resourceType==="Asset"){{/** makes assetCallBack apply only to resource of type Asset */}
      assetCallback(ft)} //  this callback is used to save the asset in a reacct state 
   })
}

function addBaseLayer(map) {
  L.tileLayer('https://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png', {
    maxZoom: 22,
    maxNativeZoom: 18,
    attribution:
      'Tiles courtesy of <a href="http://openstreetmap.org/" target="_blank">OpenStreetMap Sweden</a> &mdash; Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
  }).addTo(map)

}

function removeOverlay() {
  document.getElementById('overlay').style.visibility = 'hidden'
}

function featureInfo(ft) {
  const isSpace = ft.resourceType === 'Space'
  const isAsset = ft.resourceType === 'Asset'
  let info = `Resource Type: ${ft.resourceType}<br>`
  if (isSpace)
    info += `usage: ${camelToTitle(ft.properties.usage)}<br>
  
  asset count: ${ft.resourceRelations?.assets?.length || 0}`
  else if (isAsset){
    info += `Asset Name: ${ft.name}<br>`
    if( ft.itemWithAlarm){
    info += `Alarm detected in item : ${ft.itemWithAlarm}<br>`}
  info += `Building:${ft.serialNumber} <br>
    items :  ${ft.items}  <br>
   
    Protocol: ${ft.protocol}  <br>`
    if( ft.itemWithAlarm)
    info += `Alarm detected in item : ${ft.itemWithAlarm}<br>`
  }
  
  return info
}

function camelToTitle(key) {
  return key
    .replace(/([A-Z])/g, (match) => ` ${match.toLowerCase()}`)
    .replace(/^./, (match) => match.toUpperCase())
    .trim()
}

const catchAxiosError = (error) => {
  if (!error.response) {
    // network error
    return json(
      {},
      {
        status: 404,
      }
    );
  } else {
    const code = error.response.status;
    // const message = error.response.data.message;
    // return json(
    //   { message: message },
    //   {
    //     status: code,
    //   }
    // );
    const message = error.message;
    return { errors:[message]}
  }
};


// Load svg floor plan from Space API
export function loadFloorImg(floorId, publishableToken) {
  const url = `https://api.archilogic.com/v2/floor/${floorId}/2d-image?pubtoken=${publishableToken}`;
  const body = JSON.stringify({ format: 'svg' });

  return fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: body
  }).then(res => res.json());
}

function extractItemsString(customAssets) {
  var itemString=''
  for (var i=0;i<customAssets.length;i++){
      itemString+= (customAssets[i].serialNumber+', ')
  }
 return itemString;
}
function mapAssets(assets, customAssets) {
  var items=''
  
  if (customAssets.length <= assets.features.length) {
      for (let i = 0; i < customAssets.length; i++) {
          // Modify the corresponding element in assets
          assets.features[i].alisId = customAssets[i].id
          assets.features[i].name = customAssets[i].name;
          assets.features[i].serialNumber = customAssets[i].serialNumber;
          assets.features[i].items =  extractItemsString(customAssets[i].items);
          assets.features[i].isAssetAlarmed=isAssetAlarmed(customAssets[i].items)[0] //boolean to make asset blink on map
          assets.features[i].itemWithAlarm=isAssetAlarmed(customAssets[i].items)[1]
          assets.features[i].protocol = customAssets[i].protocol;
      }
      const numOfAssets=customAssets.length
      assets.features.length=numOfAssets
      console.log("asset feature after splice : ",assets)
  } else {
      // Custom assets array has more elements than assets array
      console.log("Custom assets array has more elements than assets array");
  }
}


// Load svg floor plan from Space API
function loadFloorPlanImage(floorId, publishableToken) {
  return fetch(
    `https://api.archilogic.com/v2/floor/${floorId}/2d-image?pubtoken=${publishableToken}`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' }
    }
  ).then((res) => res.json())
}

export async function loadFloorOnMap(floorId, publishableToken,customAssets,assetCallback,mapContainer) {
  var imageCenter =[ 41.91277786052955, 12.57372781634331]
  const map = L.map('map', {
    center: imageCenter,
    zoom: 3
  })
  // remove this if you don't want a map
  addBaseLayer(map)
  // load svg from space api
  const { imageUrl, latLngBounds } = await loadFloorPlanImage(floorId, publishableToken)
  // add as image overlay
  L.imageOverlay(imageUrl, latLngBounds).addTo(map)
  map.fitBounds(latLngBounds)
   imageCenter =[(latLngBounds[0][0] + latLngBounds[1][0]) / 2, (latLngBounds[0][1] + latLngBounds[1][1]) / 2];

  // Set the map's center to the center point of the image overlay
 
  const spaceFeatures = await loadGeoJson(floorId, 'space', publishableToken, map)
  console.log("spaceFeatures",spaceFeatures);
  const workSpaceIds = spaceFeatures.features
    .filter((spaceFeature) => spaceFeature.properties.program === 'work')
    .map((spaceFeature) => spaceFeature.id)

  // check space taxonomy for details
  // https://developers.archilogic.com/space-api/v2/space-taxonomy.html#hierarchy
  spaceFeatures.features = spaceFeatures.features.filter((spaceFeature) =>
    ['meet', 'socialize', 'care'].includes(spaceFeature.properties.program)
  )
  map.on("click", function(e){
    console.log(" electric long lat ",[e.latlng.lat, e.latlng.lng])
   // new L.Marker([e.latlng.lat, e.latlng.lng],{icon: greenMarker}).addTo(map);
 })
 
  const assetFeatures = await loadGeoJson(floorId, 'asset', publishableToken, map)
  console.log("assetFeatures : ",assetFeatures);
  
  // check product taxonomy for details
  // https://developers.archilogic.com/space-api/v2/product-taxonomy.html#hierarchy
  assetFeatures.features = assetFeatures.features.filter((assetFeature) => {
    const isWorkSpace = workSpaceIds.includes(assetFeature.resourceRelations.spaces[0])
    const isDeskOrChair =
      assetFeature.properties.subCategories.includes('desk') ||
      assetFeature.properties.subCategories.includes('taskChair')
    return isWorkSpace && isDeskOrChair
  })
 
if(customAssets){
  console.log("custom  asseets", customAssets)
  mapAssets(assetFeatures,customAssets)
}
  addGeoJson(spaceFeatures, map)
  addGeoJson(assetFeatures, map,assetCallback)
  map.setView(imageCenter,22)
  //map.setZoom(19);
  var marker = new L.Marker(imageCenter,{icon: greenMarker}).addTo(map);
 
}
